<template>
    <Card :bordered="false" class="border-radius-0" :key="data.useForm.modelRef?.id">
        <Form :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <Tabs v-model:activeKey="data.tabKey" type="card">
            <TabPane key="SequestrateInfo" :tab="$t('views.request.sequestrateInfo.title')" :forceRender="true">
                <SequestrateInfoForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        dataKey="refSequestrateTemp"
                        :isLoading="isLoading"
                ></SequestrateInfoForm>
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
    import { Card, Form, Tabs } from "ant-design-vue";
    import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
    import { useRoute } from "vue-router";
    import { state as stateApp } from "../../../../../app.logic";
    import { createFormTitle, initForm, isLoading, onClickModalOk, state } from "./request.logic";

    export default defineComponent({
        components: {
            Card,
            Form,
            Tabs,
            TabPane: Tabs.TabPane,
            TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder")),
            SequestrateInfoForm: defineAsyncComponent(() => import("./sequestrate-info/SequestrateInfoForm")),
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            routerPrefix: { default: "sequestrate-changes" },
            viewOnly: { default: false },
            form: {},
            setAppPageHeader: { default: true },
            visibleChangeLog: { default: true },
            requestTypeKeys: { default: ["2"] },
            forceDefault: { default: false },
        },
        setup(props) {
            // eslint-disable-next-line vue/no-mutating-props
            const route = useRoute();
            const id = props.form ? props.form.id : route.params?.id;
            const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [], sendReceive: false });
            const refs = reactive({ form: null });
            initForm({ props, data, refs, route });
            const callOnClickModalOk = () => onClickModalOk({ data, refs });
            const title = computed(() => createFormTitle({ props, data }));
            return {
                props,
                data,
                refs,
                state,
                title,
                isLoading,
                callOnClickModalOk
            };
        }
    });
</script>
